// 修改为 Vue 3 和 Vuex 4 的用法
import { createStore } from 'vuex'

const store = createStore({
  // ... 你的 store 配置（保持不变）
})

export default store